module.exports = __webpack_public_path__ + "media/app/assets/imgs/events/search-bar-note-bc15f744edbfa1195e25dde19c20c71a.svg";